"use client";

import Button from "./library/Button";
import FadeDiv from "./common/FadeDiv";
import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

const LearnMoreBtn: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FadeDiv className={clsx("h-48", "flex", "items-center", "justify-center")}>
      <div
        className={clsx(
          "items-center",
          "left-0",
          "h-48",
          "w-screen",
          "bg-[#FFFCF5]",
          "mb-10"
        )}
      >
        <div
          className={clsx(
            "max-w-8xl mx-auto h-full w-full",
            "border-x border-[#DADADA]",
            "flex items-center justify-center"
          )}
        >
          <Button
            className={clsx("w-full mx-4 py-4", "max-w-sm md:mx-auto")}
            href="/product"
          >
            {t("learnMoreButton.text")}
          </Button>
        </div>
      </div>
    </FadeDiv>
  );
};

export default LearnMoreBtn;
